// local storage?
// store

import { useQuery, useQueryClient } from '@tanstack/vue-query'
import { currentCustomerId } from '../../core/composables/useSessionData'
import { useApi } from '../../core/composables/useApi'

const staleTimeMs = 10 * 60 * 1000
// const staleTimeMs = 10 * 60 * 1000

export function useAccountStatusQuery() {
  const api = useApi()
  const queryClient = useQueryClient()

  const getInitialData = () => {
    // Get the query state
    const state = queryClient.getQueryState(['account-status'])
    // If the query exists and has data that is no older than 10 minutes...
    if (state && Date.now() - state.dataUpdatedAt <= staleTimeMs) {
      // return the individual todo
      return state.data
    }
    // Otherwise, return undefined and let it fetch from a hard loading state!
  }

  return useQuery({
    queryKey: ['account-status'],
    queryFn: async () => api.getCustomerAccountStatus(currentCustomerId),
    staleTime: staleTimeMs,
    initialData: getInitialData(),
    refetchInterval: staleTimeMs,
    enabled: currentCustomerId !== undefined,
    // initialDataUpdatedAt: queryClient.getQueryState('account-status')?.dataUpdatedAt,
    // initialData: queryClient.getQueryState(['account-status']),

  })
}
